import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import selector from './widthEditor.selector';
import { setGates, setSelected } from '../Construction/construction.reducer';

import SelectEdit from '../../components/SelectEdit';

import { availableType } from '../../types/available.types';
import { infoShape } from '../../types/info.types';

class WidthEditor extends React.Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    setSelected: PropTypes.func.isRequired,
    setGates: PropTypes.func.isRequired,
    available: PropTypes.arrayOf(availableType),
    info: infoShape,
    selected: PropTypes.number,
    gates: PropTypes.object.isRequired,
    translationsData: PropTypes.object, // optional if passed from parent
  };

  static defaultProps = {
    available: [],
    selected: null,
    info: null,
    translationsData: {}, // safe default
  };

  handleWidthChange = (value) => {
    const { setSelected, setGates, gates } = this.props;

    // 1. Update selected width
    setSelected('width', value);

    const selectedItem = this.props.available.find((el) => el.id === value);
    const widthCm = selectedItem?.attributes?.value_cm || 0;

    // 2. Determine new available_count
    let newAvailableCount = [];

    if (widthCm <= 450) {
      newAvailableCount = [1];
    } else if (widthCm <= 850) {
      newAvailableCount = [1, 2];
    } else if (widthCm <= 1150) {
      newAvailableCount = [1, 2, 3];
    } else {
      newAvailableCount = [1, 2, 3, 4];
    }

    const maxCount = Math.max(...newAvailableCount);

    const newCount = Math.min(gates.count, maxCount);

    const newGates = gates.gates.slice(0, newCount); // keep only allowed gates

    // 3. Build updated gates object
    const updatedGates = {
      ...gates,
      available_count: newAvailableCount,
      count: newCount,
      gates: newGates,
    };

    // 4. Dispatch updated gates
    setGates(updatedGates);
  };

  render() {
    const { loaded, selected, info, available, translationsData } = this.props;

    return loaded ? (
      <SelectEdit
        selected={selected}
        loaded={loaded}
        title={translationsData.width || 'width'}
        info={info}
        onChange={this.handleWidthChange}
        options={available.map((el) => ({
          id: el.id,
          value: `${el.attributes.value_cm}cm`,
        }))}
      />
    ) : (
      <SelectEdit loading />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setSelected: (key, value) => dispatch(setSelected(key, value)),
  setGates: (gatesObj) => dispatch(setGates(gatesObj)),
});

export default connect(selector, mapDispatchToProps)(WidthEditor);
